// extracted by mini-css-extract-plugin
export default {"skeleton-accordion":"ZW0f2K","skeleton-accordion__title":"oMX7Gy"};